// extracted by mini-css-extract-plugin
module.exports = {"chart":"StatisticsChart_chart__2R9av"};